import React, { Component } from 'react'
import { connect } from 'react-redux'
import SelectLightCurtainZone from '../selectLightCurtainZone'
import {setRoomControlPage} from '../../../action/action'
import {
  setLightSceneAction, dimCurtain, setCurtain, CMSPath, CLICKED, EXIT
} from '../../../../config/constant'
import {setCurrentWindow, setFailScreen} from '../../../../action/action'
import {
  setLightSceneInncom, setCurrentLightScene, changeCurtainInncom,
  restoreValue, getInncomRoomControlData, getTintControlData, setCurrentWindowTintPage
} from '../../../../action/roomControlAction'
import { roomThemeColorConfig, clearConfig } from '../../../JS/colorConfig'
import DefaultImage from '../../../../images/defaultAsset/bg_lights.png'
import { scrollUpEffect, scrollDownEffect, removeScrollDown } from '../scrollEffect';
import $ from 'jquery'
import { dynamicHeight } from '../../../JS/listItemHeightFix';
import WindowTintControl from './WindowTintControl/windowTintControl'
import view_logo from './assets/view_sw_logo.png'
import Loader from '../../../UI/loader'
import { calculateTimeDifference, getDefaultAnalyticsLabel } from '../../../JS/utility'
import { sendAnalytics } from "../../../../action/homeAction";
import { setGoHome, setLoader } from '../../../action/homeAction'
import WindowSleepin from './WindowTintControl/WindowSleepin'
import WindowZones from './WindowTintControl/WindowZones'

import sleepin_icon from "./assets/tint/ico_clock.svg";
import zones_icon from "./assets/tint/ico_window.svg";
import ActiveOverride from './WindowTintControl/ActiveOverride'
import { scrollToTop } from '../../../../JS/scrollToTop'
import { closeOrderPopUp } from '../../../action/hCommerce2'
import { PowerIcon } from './MultiController'


class RoomTheme extends Component {

  constructor(props) {
    super(props);
    this.state = {
      currentCurtain: null,
      currentLightscene: null,
      showTintControl: true,
      widgetLaunchTime: new Date,
      widgetName: this.props.currentWidget.displayName
    }

    this.appBodyPaddBottom = null;
    
  }

  componentDidUpdate() {
    roomThemeColorConfig(this.props.menuColor);
    dynamicHeight();
  }

  componentDidMount(){
    dynamicHeight();
  }

  goBack = (event) => {
    if(event) event.preventDefault();
    this.props.setRoomControlPage("");
    if (this.props.zoneCount > 1) {
      if (this.props.seletedIndex || this.props.seletedIndex === 0) {

      } else {
        window.history.back();
      }
      this.props.restoreValue(this.props.VDAZoneList);
    } else {
      window.history.back();
    }
  }

  showListOfZone = () => {
    let da = [];
    let len = this.props.VDAZoneList.length
    for (let i = 0; i < this.props.VDAZoneList.length; i++) {
      console.log("I=", i)
      da[i] =

        <div className="col col-2 flex-nowrap">
          <a className="tile-sm thumbnails tile-container selected">
            <div className="thumb-img">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25.9 25.9"><title>Day</title><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><circle className="cls-1" cx="12.95" cy="12.95" r="7.56" /><polygon className="cls-1" points="11 3.86 12.95 0 14.9 3.86 11 3.86" /><polygon className="cls-1" points="11 22.04 12.95 25.9 14.9 22.04 11 22.04" /><polygon className="cls-1" points="18 5.15 22.11 3.79 20.75 7.9 18 5.15" /><polygon className="cls-1" points="5.15 18 3.79 22.11 7.9 20.75 5.15 18" /><polygon className="cls-1" points="22.04 11 25.9 12.95 22.04 14.9 22.04 11" /><polygon className="cls-1" points="3.86 11 0 12.95 3.86 14.9 3.86 11" /><polygon className="cls-1" points="20.75 18 22.11 22.11 18 20.75 20.75 18" /><polygon className="cls-1" points="7.9 5.15 3.79 3.79 5.15 7.9 7.9 5.15" /></g></g></svg>
            </div>
            <div className="thumb-text align-center">
              <p className="thumb-heading">Day</p>
              <p>All Lights On</p>
            </div>
          </a>
        </div>


    }

    return (
      <div>
        {
          da.map((itrator) => {
            return (
              <div className="row">{itrator} </div>
            )
          })
        }
      </div>
    )
  }

  selectLightScene = (id, mode, lightScreen) => {
    const statusCallback=(status)=>{
      this.props.setLoader(false);
      if (status) {
        this.props.closeOrderPopUp(true, `Request sent successfully`, "", false);
      } else { 
        this.props.closeOrderPopUp(true,`Something went wrong while sending request`, "", true)
      }
    }     

    this.props.setLoader(true, "Sending Request..." , false)
    this.props.setLightSceneInncom( id, "setLightCtrlScene", this.props.guestDetail, statusCallback, this.props.roomControlSpecificVersion);
    this.setState({currentLightscene:`${lightScreen.lightCode}`});
    console.log("id", `${lightScreen.lightCode}`);
  }

  selectCurtain = (curtain, mode, status) => {
    let action;
    //onControlClick(`curtain${curtain.id}${status}`, mode, this.props.menuColor);
    this.setState({ currentCurtain: `${curtain.curtainCode}` });
    if((localStorage.getItem("roomControlInterface") || process.env.REACT_APP_ROOMCONTROLTYPE) == 'Lutron'){
      action = 'setCurtain'
    } else {
      if (status === "OFF") {
        action = "openAllDrapes"
      } else {
        action = "closeAllDrapes"
      }
    }
    this.props.changeCurtainInncom(`${curtain.curtainCode}`, action, this.props.guestDetail);
    //this.VDAApiCall();
  }

  onWindowClick = (window, index) => {
    // this.props.setRoomControlPage('windowTintControl')
    this.props.setCurrentWindow([window,index])
  }

  componentWillUnmount(){
    // $('#app-body').css("padding-bottom",this.appBodyPaddBottom);
    removeScrollDown();
    clearConfig(this.props.menuColor);
    this.props.setCurrentLightScene(null);

    // Send Analytics
    if(this.props.guestIsLoggedIn){
      let widgetCloseTime = new Date

      let duration = calculateTimeDifference(this.state.widgetLaunchTime, widgetCloseTime, 'second');
      let label = getDefaultAnalyticsLabel({appVersion: this.props.installedAppVersion ? `${this.props.installedAppVersion}(${this.props.installedAppBuildNo})` : ""})
      this.props.sendAnalytics(
          this.props.guestDetail, 
          this.state.widgetName, 
          EXIT, 
          {...label, "layoutTab": this.props.currentHomePage.tabName, "element": "widget", "duration": duration}, 
          0, 
          this.props.guestIsLoggedIn
      );
    }

    this.props.setCurrentWindowTintPage("")
    //

  }

  componentDidMount(){
    if(!this.props.guestIsLoggedIn || this.props.stopCompDidMound) return
    // this.props.getTintControlData(this.props.guestDetail, this.getTintControldataCallback)
    window.scrollTo(0,0);
    scrollUpEffect("div.customOverlay",this.props.menuColor);
    // this.appBodyPaddBottom = $('#app-body').css("padding-bottom");
    // $('#app-body').css("padding-bottom","0");

    // Send Analytics
    if(this.props.guestIsLoggedIn){
      let label = getDefaultAnalyticsLabel({appVersion: this.props.installedAppVersion ? `${this.props.installedAppVersion}(${this.props.installedAppBuildNo})` : ""})
      this.props.sendAnalytics(
          this.props.guestDetail, 
          this.props.currentWidget.displayName, 
          CLICKED, 
          {...label, "layoutTab": this.props.currentHomePage.tabName, "element": "widget"}, 
          0, 
          this.props.guestIsLoggedIn
      );
    }

  }


  render() {//backgroundColor:"transparent"

    scrollDownEffect(null,"section",this.props.menuColor,3.6)
    console.log('this.props.menuColor',this.props.menuColor)
    
//backgroundImage: `linear-gradient(90deg, ${this.props.menuColor.assetBackgroundSelectorColor}66, rgba(255,255,255,0)),url('${DefaultImage}')`, backgroundRepeat:"no-repeat",
    return (
   this.props.OnHomeScreen?<>
  {this.props.curtainData && this.props.curtainData.curtain && this.props.curtainData.curtain.length > 0 && 
      <div class="room-control-list">
          <div class="room-control-item">
            <div class="room-control-item-label 6666">{this.props.curtainData.curtainSubTypeLabel}</div>
              <div class="room-control-buttons">
              {this.props.curtainData.curtain.map((curtain, idx) => (
               <button className="button-text"
               onClick={() => { this.selectCurtain(curtain, "curtains", curtain.currentState) }}>
                <img src={`${CMSPath}${curtain.curtainIconImgUrl}`} />
                </button>
                 ))}
            </div>
          </div>
        </div>
  }

      {this.props.lightData && this.props.lightData.lights && this.props.lightData.lights.length > 0 && 
     <div className="room-control-list">
     <div className="room-control-item">
       <div className="room-control-item-label">{this.props.lightData.lightsSubTypeLabel}</div>
         <div className="room-control-buttons">
           {this.props.lightData.lights.map((light, idx) => (
           <button className="button-text"
               onClick={() => {
                this.selectLightScene(`${light.lightCode}`,
                  "lightMood", light)
              }}
           >
            <img src={`${CMSPath}${light.lightIconImgUrl}`} />
           </button>
             ))}
         </div>
     </div>
   </div>
        }
</>
:
        
      <div className="main-container "
          style = {{
            height: "100vh",backgroundSize:"cover",backgroundPosition:"center", backgroundAttachment:"fixed"
          }}
        >{console.log('Room Theme Rendered from Inncom', this.props.currentTintWindow)}
        {
          !this.props.currentTintWindow ? <>
          <header id = "header" className="inner-pages subpages no-background" style = {{background: this.props.menuColor.assetBackgroundSelectorColor, boxShadow:"unset",border:"none", position: "sticky"}}>{/*,position:"sticky" */}
            <div className = "customOverlay" style = {{transition:"0.3s", position:"absolute",top:"0", left:"0", width: "100%", height:"85px", zIndex:"-1", background:"transparent"}}></div>
            <a onClick={this.goBack}
              className="button-back"></a>
            <div className="heading align-center">
              <div class="splash-brand">
                  <img src={`${CMSPath}${this.props.logo}`} />
              </div>
              {/* <p className="bold" style = {{color: this.props.menuColor.assetFontSelectorColor}}>{this.props.currentWidget.displayName}</p> */}
            </div>
          </header>
            <section id="customizeRoom" className="widgets padding-bottom-2 margin-0" style = {{paddingTop: "0"}}>

                <div class="widget-header widget-header-checkin">
                    { this.props.currentWidget.widgetHeaderImageUrl && 
                        <div class="widget-header-img">
                            <img src={`${CMSPath}${this.props.currentWidget.widgetHeaderImageUrl}`} alt={this.props.currentWidget.displayName} />
                        </div>
                    }
                    <div class="widget-header-title">{this.props.currentWidget.displayName}</div>
                </div>

              <div className="widgets">
                {this.props.lightScene.length >= 1 ?
                  <div className="row">
                    <div className="col">
                      <p className="heading" style={{color: this.props.menuColor.assetFontColor}}>Light Scene</p>
                    </div>
                  </div> : null}
                {this.props.lightScene.length >= 1 ?
                  <div className="row">
                    <div className="col col-2 menu-items">
                      {this.props.lightScene.map((iterator, lightIndex) => {
                        if (lightIndex < this.props.lightScene.length) {
                          return (
                            <a
                              onClick={() => {
                                this.selectLightScene(`${iterator.lightCode}`,
                                  "lightMood", iterator)
                              }}
                              className=
                              // {this.props.currentLightscene === 
                                // `${iterator.lightCode}` ?
                                // "tile-sm thumbnails tile-container selected " :
                                "tile-sm thumbnails tile-container">
                              <div className="thumb-img">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25.9 25.9"><title>Day</title><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><circle className="cls-1" cx="12.95" cy="12.95" r="7.56" /><polygon className="cls-1" points="11 3.86 12.95 0 14.9 3.86 11 3.86" /><polygon className="cls-1" points="11 22.04 12.95 25.9 14.9 22.04 11 22.04" /><polygon className="cls-1" points="18 5.15 22.11 3.79 20.75 7.9 18 5.15" /><polygon className="cls-1" points="5.15 18 3.79 22.11 7.9 20.75 5.15 18" /><polygon className="cls-1" points="22.04 11 25.9 12.95 22.04 14.9 22.04 11" /><polygon className="cls-1" points="3.86 11 0 12.95 3.86 14.9 3.86 11" /><polygon className="cls-1" points="20.75 18 22.11 22.11 18 20.75 20.75 18" /><polygon className="cls-1" points="7.9 5.15 3.79 3.79 5.15 7.9 7.9 5.15" /></g></g></svg>
                              </div>
                              <div className="thumb-text align-center" style={{ color: "inherit" }}>
                                <p className="thumb-heading" style={{ color: "inherit" }}>{iterator.lightLabel}</p>
                                {/* <p style={{ color: "inherit" }}>{this.state.currentLightscene === `${iterator.lightCode}` ?
                                  "Light Scene On" : "Light Scene Off"
                                }</p> */}
                                 <button>{<PowerIcon/>}</button>
                              </div>
                            </a>
                          )
                        }
                      })
                      }
                    </div>
                  </div>
                  : null}
              </div>
              <div className="widgets">
                {this.props.curtain.length > 0 ?
                  <div className="row">
                    <div className="col">
                      <p className="heading" style={{color: this.props.menuColor.assetFontColor}}>Curtains</p>
                    </div>
                  </div> : null
                }
                <div className="row">
                  <div className="col col-2 menu-items">
                    {
                      this.props.curtain.length >= 1 ?
                        this.props.curtain.map((itrator, curtainIndex) => {
                          if (curtainIndex < this.props.curtain.length) {
                            return (
                              < a className=
                                // {this.state.currentCurtain ===
                                  // `${itrator.curtainCode}` ?
                                  // "tile-sm thumbnails tile-container selected " :
                                  "tile-sm thumbnails tile-container "
                                onClick={() => { this.selectCurtain(itrator, "curtains", itrator.currentState) }} >
                                <div className="thumb-img">
                                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 791.09 736.84"><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><rect width="791.09" height="63.86" rx="31.93"/><path d="M353.19,123.63c0,.15,0,.29,0,.44,0,17.16-12.52,31.07-28,31.07s-28-13.91-28-31.07c0-.15,0-.29,0-.44H269.57c0,.15,0,.29,0,.44,0,17.16-12.52,31.07-28,31.07s-28-13.91-28-31.07c0-.15,0-.29,0-.44h-26.8v3.52c-1.39,15.71-13.31,28-27.82,28-15.45,0-28-13.91-28-31.07,0-.15,0-.29,0-.44H103.37c0,.15,0,.29,0,.44,0,17.16-12.52,31.07-28,31.07s-28-13.91-28-31.07c0-.15,0-.29,0-.44H20.66V706.84c0,16.57,12.09,30,27,30H379.33V123.63Z"/><path d="M743.63,123.63c0,.15,0,.29,0,.44,0,17.16-12.52,31.07-28,31.07s-28-13.91-28-31.07c0-.15,0-.29,0-.44H660c0,.15,0,.29,0,.44,0,17.16-12.52,31.07-28,31.07-14.51,0-26.43-12.28-27.83-28v-3.52H577.43c0,.15,0,.29,0,.44,0,17.16-12.52,31.07-28,31.07s-28-13.91-28-31.07c0-.15,0-.29,0-.44H493.8c0,.15,0,.29,0,.44,0,17.16-12.52,31.07-28,31.07s-28-13.91-28-31.07c0-.15,0-.29,0-.44H411.76V736.84H743.43c14.91,0,27-13.43,27-30V123.63Z"/></g></g></svg>                              
                                </div>
                                <div className="thumb-text align-center">
                                  <p className="thumb-heading">{itrator.curtainLabel}</p>
                                  <p>{
                                    itrator.currentState === "ON" ?
                                      `Close ${itrator.curtainLabel}` : `Open ${itrator.curtainLabel}`}
                                  </p>
                                </div>
                              </a>
                            )
                          }
                        })
                        : null
                    }
                  </div>
                </div>
              </div>
              { this.props.windows && this.props.windows.length > 0 && <div class="widgets">
                <div class="row">
                  <div class="col">
                    <p class="heading">View Smart Windows</p>
                  </div>
                </div>
                <div class="row">
                  <div class="col col-2 menu-items">
                    <a onClick={() => {this.props.setCurrentWindowTintPage("Override"); scrollToTop()}} class="tile-sm thumbnails tile-container">
                      <div class="thumb-img">
                        <img src={zones_icon}/>
                      </div>
                      <div class="thumb-text align-center">
                        <p class="thumb-heading">Override</p>
                      </div>
                    </a>
                    <a onClick={() => {this.props.setCurrentWindowTintPage("SleepIn"); scrollToTop()}} class="tile-sm thumbnails tile-container">
                      <div class="thumb-img">
                        <img src={sleepin_icon}/>
                      </div>
                      <div class="thumb-text align-center">
                        <p class="thumb-heading">Sleep-in</p>
                      </div>
                    </a>
                  </div>
                </div>
              </div>}
            </section>
            
            <ActiveOverride response={this.props.tintControlData} />
            </>
            : <>
              { this.props.currentTintWindow == "Override" &&  <WindowZones goBack={() => this.props.setCurrentWindowTintPage("")} />}
              { this.props.currentTintWindow == "SleepIn" && <WindowSleepin goBack={() => this.props.setCurrentWindowTintPage("")} />}
            </> }
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    guestDetail: state.store.home.guestDetails,
    currentWidget: state.store.sideNavBar.currentWidget,
    logo: state.store.home.currentDuration.brandingInfo ?
            state.store.home.currentDuration.brandingInfo.hotelLogoImageUrl : "",
    selectedZone: state.store.roomControl.selectedZone,
    VDAZoneList: state.store.roomControl.VDAZoneList,
    currentLightscene: state.store.roomControl.currentLightscene,
    menuColor: state.store.home.MenuColor,
    currentCurtain: state.store.roomControl.currentCurtain,
    seletedIndex: state.store.roomControl.seletedIndex,
    zoneCount: state.store.roomControl.zoneCount,
    menuColor: state.store.home.MenuColor,
    lightScene: state.store.InncomRoomControl.lightScene,
    curtain: state.store.InncomRoomControl.curtain,
    currentWindow: state.store.currentWindow,
    windows: state.store.TintControlData.zone,
    guestIsLoggedIn: state.store2.guestIsLoggedIn,
    installedAppVersion: state.store.installedAppVersion,
    installedAppBuildNo: state.store.installedAppBuildNo,
    currentHomePage: state.store2.currentHomePage,
    currentTintWindow: state.store.currentTintWindow,
    tintControlData: state.store.TintControlData,
    roomControlSpecificVersion: state.store.home.clientConfig.webAppWidgetsInfo && state.store.home.clientConfig.webAppWidgetsInfo.appConfigs && state.store.home.clientConfig.webAppWidgetsInfo.appConfigs.roomControlSpecificVersion,


  }
}
export default connect(
  mapStateToProps,
  {
    // setRegPage,
    // VDAStatusApi
    setLightSceneInncom,
    setCurrentLightScene,
    changeCurtainInncom,
    restoreValue,
    getInncomRoomControlData,
    setRoomControlPage,
    getTintControlData,
    setCurrentWindow,
    sendAnalytics,
    setFailScreen,
    setGoHome,
    setCurrentWindowTintPage,
    setLoader,
    closeOrderPopUp
  }
)(RoomTheme);